import { Button } from '@cian/ui-kit';
import * as React from 'react';

import { TFlatViewButtonComponent } from '../../types';

// TODO: В CD-235461 убрать директиву ниже и удалить пропсы fullWidth и theme.
/* istanbul ignore next */
export const FlatViewButton: TFlatViewButtonComponent = ({
  onClick,
  disabled,
  beforeIcon,
  fullWidth = true,
  theme = 'fill_secondary',
}) => {
  return (
    <Button theme={theme} size="M" onClick={onClick} disabled={disabled} fullWidth={fullWidth} beforeIcon={beforeIcon}>
      Записаться на просмотр
    </Button>
  );
};
